// Axios instance + interceptors
import axios from 'axios';

// Use relative URL for production, absolute for development
// In production (when built), this will use the same origin as the page
// Apache will proxy /api/v1/* to the backend on port 8080
export const API_BASE = process.env.REACT_APP_API_BASE || '/api/v1';

console.log('API Base URL:', API_BASE);

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    console.log(`🚀 API Request: ${config.method?.toUpperCase()} ${config.url}`, {
      data: config.data,
      params: config.params,
      headers: config.headers,
    });

    return config;
  },
  (error) => {
    console.error('❌ Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    console.log(`✅ API Response: ${response.config.method?.toUpperCase()} ${response.config.url}`, {
      status: response.status,
      data: response.data,
    });
    return response;
  },
  (error) => {
    console.error(`❌ API Error: ${error.config?.method?.toUpperCase()} ${error.config?.url}`, {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      message: error.message,
    });

    // Enhanced 401 error handling for token expiration
    if (error.response?.status === 401) {
      const errorMessage = error.response?.data?.error || 'Unauthorized';
      console.error('🔐 Authentication Error Details:', {
        error: errorMessage,
        url: error.config?.url,
        hasToken: !!localStorage.getItem('auth_token'),
        tokenLength: localStorage.getItem('auth_token')?.length || 0
      });

      // If token expired, clear it and redirect to login
      if (errorMessage.includes('expired') || errorMessage.includes('Token expired')) {
        console.warn('🔐 Token expired, clearing localStorage and redirecting to login');
        localStorage.removeItem('auth_token');
        // Trigger a page reload to force re-authentication
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }

    return Promise.reject(error);
  }
);

export { api };
export default api;
